<ng-template #modal let-c="close" let-d="dismiss" class="modal-md fade">
  <ng-content></ng-content>
</ng-template>
